import { GlassPanel } from '../ui/GlassPanel';

const SKILLS = [
  'Backend Architecture',
  'AI & LLM Systems',
  'Data Engineering',
  'Process Automation',
  'Service Integration',
  'Infrastructure Management',
  'Database Design',
  'Cloud Deployment',
  'Frontend Development',
  'Distributed Systems',
  'Networking',
  'Microservices',
];

/**
 * SkillsCard — capabilities as a clean tag list.
 * Focuses on what Simone can DO, not just which tools he knows.
 */
export function SkillsCard() {
  return (
    <GlassPanel
      as="section"
      aria-label="Skills and capabilities"
      className="flex flex-col gap-4 p-5 lg:p-6 h-full overflow-hidden"
    >
      <h2 className="text-xs font-semibold tracking-widest uppercase text-[var(--color-muted)]">
        Capabilities
      </h2>

      <ul
        className="flex flex-wrap gap-2 content-start overflow-hidden"
        aria-label="Professional capabilities"
      >
        {SKILLS.map((skill) => (
          <li
            key={skill}
            className="
              text-xs px-2.5 py-1 rounded-lg
              bg-white/[0.04] border border-white/[0.06]
              text-[var(--color-muted)]
              hover:text-[var(--color-text)] hover:border-[var(--color-accent)]/30
              transition-colors cursor-default
              select-none
            "
          >
            {skill}
          </li>
        ))}
      </ul>
    </GlassPanel>
  );
}
